.hero {
  position: relative;
  background: var(--color-primary-blue-100); /* blue-100 (soft blue hero wash) — matches the other static pages */
  padding: 60px 0 66px;
  overflow: hidden;
}

/* 6px accent (yellow) bottom rule, as in the design */
.hero::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 6px;
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW (accent) */
}

.hero__inner {
  position: relative;
  display: grid;
  grid-template-columns: 1.25fr 1fr;
  align-items: center;
  gap: 48px;
}

/* let both tracks shrink below content so the artwork / a long word can't blow out the grid */
.hero__text,
.hero__art {
  min-width: 0;
}

.hero__breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-tertiary); /* text-3 */
  margin-bottom: 30px;
}

.hero__breadcrumbTag {
  background: var(--color-primary-blue-900); /* PRIMARY_BLUE_900 */
  color: var(--color-primary-grey-000);
  padding: 5px 13px;
  border-radius: 9999px;
  letter-spacing: 0.06em;
}

.hero__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: clamp(44px, 6vw, 80px);
  line-height: 1;
  letter-spacing: -0.015em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 22px;
  text-wrap: balance;
}

.hero__highlight {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  font-style: italic;
}

.hero__lede {
  font-size: 19px; /* HEADING_XS */
  line-height: 1.55;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
  max-width: 42ch;
  margin: 0 0 34px;
}

.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.hero__art {
  display: flex;
  justify-content: center;
}

/* Montage of a few sticker badges (2×2), each tilted so they read as a scattered sticker set. */
.hero__montage {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  width: clamp(260px, 34vw, 480px);
}

.hero__sticker {
  width: 100%;
  height: auto;
}

.hero__sticker:nth-child(1) {
  transform: rotate(-6deg);
}
.hero__sticker:nth-child(2) {
  transform: rotate(5deg);
}
.hero__sticker:nth-child(3) {
  transform: rotate(4deg);
}
.hero__sticker:nth-child(4) {
  transform: rotate(-5deg);
}

@media (max-width: 880px) {
  .hero__inner {
    grid-template-columns: 1fr;
  }

  /* drop the sticker montage on narrow screens, like the other static heroes */
  .hero__art {
    display: none;
  }
}
